import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { customDataLayerPush } from 'src/utils/analytics';
import { DL_EVENT, LABEL, PAGE_SLOT } from 'src/utils/analytics/constants';
import { PAGE } from '../../../constants/pages';
import Section from '../../../containers/Section';
import Brands from '../../Brands';
import GradientTitle from '../../GradientTitle';
import { HeaderVariant } from '../../Header';
import HeroCtas from '../../HeroCtas';
import Paragraph from '../../Paragraph';
import Orbit from './Orbit';

interface HeroSectionProps {
  title: string[];
  description: string;
  cta: any;
  gradientPosition: number;
  requestDemo?: any;
  secondaryCta: any;
  thirdCta?: any;
  page?: string;
}

const HeroSection: React.FC<HeroSectionProps> = props => {
  const {
    title,
    description,
    cta,
    gradientPosition,
    secondaryCta,
    page,
    thirdCta,
  } = props;

  return (
    <Section className="pb-22 md:pb-24 lg:pb-18 pt-28 md:pt-30 2xl:pt-37">
      <div className="flex flex-col lg:flex-row mb-20">
        <div className="flex flex-col justify-center text-center md:text-left w-full lg:w-1/2">
          <GradientTitle
            gradientPosition={gradientPosition}
            className="text-4xl md:text-7xl font-semibold md:font-bold"
            color="purple"
            variant={HeaderVariant.h1}
            title={title}
            lineBreak={false}
          />
          <Paragraph className="max-w-[38rem]">
            {description && description}
          </Paragraph>
          <HeroCtas
            // CTA section is shared between homepage and /sellics-joins-perpetua/
            page={page}
            cta={cta}
            secondaryCta={secondaryCta}
            thirdCta={thirdCta}
            onClickFirstCTA={() => customDataLayerPush(DL_EVENT.elementClick, {label: LABEL.Signup, pageSlot: PAGE_SLOT.Hero})}
            onClickSecondCTA={() => customDataLayerPush(DL_EVENT.elementClick, {label: LABEL.Demo, pageSlot: PAGE_SLOT.Hero})}
            // onClickThirdCTA={() => customDataLayerPush(DL_EVENT.elementClick, {label: 'CUSTOM'})}
          />
        </div>
        {page === PAGE.SELLICS_JOINS_PERPETUA ? (
          <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
            <StaticImage
              src="../../../images/sellics-keyword/hero.png"
              alt={'Hero Image'}
              className="w-full md:h-full h-1/2"
            />
          </div>
        ) : (
          <div className="hidden w-1/2 lg:block">
            <Orbit />
          </div>
        )}
      </div>
      <Brands/>
    </Section>
  );
};

export default HeroSection;
